// extracted by mini-css-extract-plugin
module.exports = {"divider":"style-module__divider___3Wtox","vertical":"style-module__vertical___1LopO"};